import type { CarouselOption } from 'src/features/home/components/videos/videos.types';
import Networks from 'src/images/pngs/home/networks.png';

export const videos: CarouselOption[] = [
  {
    id: '1',
    label: 'Exercises in every lesson',
    value: 'https://player.vimeo.com/video/554897147?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    description:
      'TryHackMe goes beyond textbooks and focuses on fun, interactive lessons that put theory into practice. Access an immersive learning experience with network simulations and intentionally vulnerable technology based on real-world scenarios, plus much more.',
  },
  {
    id: '2',
    label: 'Beginner-friendly',
    value: 'https://player.vimeo.com/video/554870915?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    description:
      'New to security? No problem! We have learning paths that will teach you the fundamental cyber security skills, which will help set you up to land a job in cyber security.',
  },
  {
    id: '3',
    label: 'Start hacking instantly',
    value: 'https://player.vimeo.com/video/554870858?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    description:
      "We give you all the tools you need to start learning. Access a machine with the security tools you'll need through the browser, and starting learning from anywhere at any time. All you need is an internet connection!",
  },
  {
    id: '4',
    label: 'Real-world networks',
    value: Networks,
    description:
      'Take your cyber security training to the next stage by learning to attack and defend computer networks similar to those used by various organisations today.',
  },
];
